const KEY = "wallace-tv:profile_id";

export function getActiveProfileId(): string | null {
  return localStorage.getItem(KEY);
}

export function setActiveProfileId(id: string): void {
  localStorage.setItem(KEY, id);
}

export function clearActiveProfileId(): void {
  localStorage.removeItem(KEY);
}
